import Vue from "vue";
import httpManager from '../../util/common'
import {reportYear,entityOaid} from '../../util/util'

const report_year_list = reportYear.esg_report_years
let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      oaid: null,
      industry: "",
      officialName: "",
      report_date: [],
      report_option: "0",
      report_list: null,
      report_month_list: null,
      selectEvent: false,
    }
  },
  methods: {
    generate_report_year_list() {
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_month_list =result.report_month_list
        self.report_list = result.report_annual_list.slice(0,-1)
        self.getESGData()
        let id = this.$route.params.oaid
        entityOaid.oaid(id).then(result => {
          self.oaid =result
        })
      })
      
    },
    getESGData(){
      this.report_date = []
      if (this.report_option === "0") {
        this.report_date = this.report_month_list.slice(0, 12)
      } else {
        for (let i in this.report_month_list) {
          if (this.report_month_list[i].startsWith(this.report_option)) {
            this.report_date.push(this.report_month_list[i])
          }
        }
      }
    }
  },
  mounted() {
    this.generate_report_year_list()
  },
  watch: {
    report_option: function () {
      this.getESGData()
      this.selectEvent = !this.selectEvent
    }
  }
}
Vue.component("esg-entity-indicator-month", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_entity_indicator_month.js